import { initTheme } from "@/utils/theme";

import { IChannelConfigs, IChannelTheme } from "../types";
const theme: IChannelTheme = {};
export default {
  configs: {
    currency: "USD",
    showLanguages: true,
    notGoFrontPage: true, // 首页登陆不跳转前置页
    telephoneCountryCode: "81",
    useChannelLanguages: true
  },
  init() {
    initTheme(theme);
  }
} as IChannelConfigs;
